export default "__VITE_ASSET__xCsnOx_k__"